import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetWarehouse, saveWarehouse } from "./index";

// Api's
import { warehouseApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getWarehouseSaga(action: GetWarehouse) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(warehouseApi.getDomain, action.payload.request);

		if (response.data.result) {
			yield put(saveWarehouse(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveWarehouse(null, true, resultError.messagesDataError));
		}
	}
}
